<template>
  <v-card color="#e1e1e1">
    <v-card-title class="d-flex justify-center">Total Inventory</v-card-title>
    <v-card-text class="text-center">
      <h1>{{ totalRecords }}</h1>
    </v-card-text>
  </v-card>
</template>

<script>
import { gql } from "apollo-boost";
export default {
  name: "TotalInventoryStatisticsCard",
  data() {
    return {
      totalRecords: 0,
      isLoading: false,
    };
  },
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    inventoryItems: {
      query: gql`
        query InventoryItems($limit: Int!, $skip: Int!, $query: JSON!) {
          inventoryItems(limit: $limit, skip: $skip, query: $query) {
            count
          }
        }
      `,
      skip() {
        return !this.me;
      },
      variables() {
        const self = this;
        const limit = 9999999;
        const skip = 0;
        const searchQuery = this.search;
        return {
          limit: limit,
          skip: skip,
          query: {},
        };
      },
      result({ data }, key) {
        console.log("yeah data appeared", data);
        this.totalRecords = data.inventoryItems.count;
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
